// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit_surgery.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { EntityRef } from "./pursuit_read_pb";
/**
 * kind ∈ rfi_response_link | interaction | workstream_item | task | document | teaming_link |
 *        competitive_participant | recompete_link | stakeholder | proposal_link
 * mode ∈ move | link | detach
 *
 * @generated from message mono.projectdata.v1.PursuitSurgeryComponent
 */ export class PursuitSurgeryComponent extends Message {
    static fromBinary(bytes, options) {
        return new PursuitSurgeryComponent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitSurgeryComponent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitSurgeryComponent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitSurgeryComponent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * row id; for kind=document the artifact id
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string mode = 3;
   */ _define_property(this, "mode", ""), /**
   * read-only in Plan responses
   *
   * @generated from field: string label = 4;
   */ _define_property(this, "label", ""), /**
   * Plan: false when blocked
   *
   * @generated from field: bool movable = 5;
   */ _define_property(this, "movable", false), /**
   * Plan: e.g. "has black hat versions"
   *
   * @generated from field: string blocked_reason = 6;
   */ _define_property(this, "blockedReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitSurgeryComponent, "runtime", proto3);
_define_property(PursuitSurgeryComponent, "typeName", "mono.projectdata.v1.PursuitSurgeryComponent");
_define_property(PursuitSurgeryComponent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "movable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "blocked_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PlanPursuitSurgeryRequest
 */ export class PlanPursuitSurgeryRequest extends Message {
    static fromBinary(bytes, options) {
        return new PlanPursuitSurgeryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlanPursuitSurgeryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlanPursuitSurgeryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlanPursuitSurgeryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlanPursuitSurgeryRequest, "runtime", proto3);
_define_property(PlanPursuitSurgeryRequest, "typeName", "mono.projectdata.v1.PlanPursuitSurgeryRequest");
_define_property(PlanPursuitSurgeryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PlanPursuitSurgeryResponse
 */ export class PlanPursuitSurgeryResponse extends Message {
    static fromBinary(bytes, options) {
        return new PlanPursuitSurgeryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlanPursuitSurgeryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlanPursuitSurgeryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlanPursuitSurgeryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitSurgeryComponent components = 1;
   */ _define_property(this, "components", []), /**
   * readable only; when any is unreadable, review is required anyway
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef impacted_proposals = 2;
   */ _define_property(this, "impactedProposals", []), /**
   * @generated from field: bool review_required_if_moving_rfis = 3;
   */ _define_property(this, "reviewRequiredIfMovingRfis", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlanPursuitSurgeryResponse, "runtime", proto3);
_define_property(PlanPursuitSurgeryResponse, "typeName", "mono.projectdata.v1.PlanPursuitSurgeryResponse");
_define_property(PlanPursuitSurgeryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "components",
            kind: "message",
            T: PursuitSurgeryComponent,
            repeated: true
        },
        {
            no: 2,
            name: "impacted_proposals",
            kind: "message",
            T: EntityRef,
            repeated: true
        },
        {
            no: 3,
            name: "review_required_if_moving_rfis",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SplitPursuitRequest
 */ export class SplitPursuitRequest extends Message {
    static fromBinary(bytes, options) {
        return new SplitPursuitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitPursuitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitPursuitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitPursuitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string source_capture_project_id = 1;
   */ _define_property(this, "sourceCaptureProjectId", ""), /**
   * @generated from field: string new_name = 2;
   */ _define_property(this, "newName", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitSurgeryComponent components = 3;
   */ _define_property(this, "components", []), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * one per dialog open; a retry returns the same new pursuit
   *
   * @generated from field: string request_id = 5;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: bool proposal_review_ack = 6;
   */ _define_property(this, "proposalReviewAck", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitPursuitRequest, "runtime", proto3);
_define_property(SplitPursuitRequest, "typeName", "mono.projectdata.v1.SplitPursuitRequest");
_define_property(SplitPursuitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "components",
            kind: "message",
            T: PursuitSurgeryComponent,
            repeated: true
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposal_review_ack",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SplitPursuitResponse
 */ export class SplitPursuitResponse extends Message {
    static fromBinary(bytes, options) {
        return new SplitPursuitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SplitPursuitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SplitPursuitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SplitPursuitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string new_capture_project_id = 1;
   */ _define_property(this, "newCaptureProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.PursuitSurgeryEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SplitPursuitResponse, "runtime", proto3);
_define_property(SplitPursuitResponse, "typeName", "mono.projectdata.v1.SplitPursuitResponse");
_define_property(SplitPursuitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "new_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: PursuitSurgeryEvent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MergePursuitsRequest
 */ export class MergePursuitsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergePursuitsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergePursuitsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergePursuitsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergePursuitsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string loser_capture_project_id = 1;
   */ _define_property(this, "loserCaptureProjectId", ""), /**
   * @generated from field: string survivor_capture_project_id = 2;
   */ _define_property(this, "survivorCaptureProjectId", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: bool proposal_review_ack = 5;
   */ _define_property(this, "proposalReviewAck", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergePursuitsRequest, "runtime", proto3);
_define_property(MergePursuitsRequest, "typeName", "mono.projectdata.v1.MergePursuitsRequest");
_define_property(MergePursuitsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "loser_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "survivor_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposal_review_ack",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MergePursuitsResponse
 */ export class MergePursuitsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergePursuitsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergePursuitsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergePursuitsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergePursuitsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PursuitSurgeryEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergePursuitsResponse, "runtime", proto3);
_define_property(MergePursuitsResponse, "typeName", "mono.projectdata.v1.MergePursuitsResponse");
_define_property(MergePursuitsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: PursuitSurgeryEvent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MovePursuitComponentsRequest
 */ export class MovePursuitComponentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MovePursuitComponentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MovePursuitComponentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MovePursuitComponentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MovePursuitComponentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string from_capture_project_id = 1;
   */ _define_property(this, "fromCaptureProjectId", ""), /**
   * empty only when every component is detach
   *
   * @generated from field: string to_capture_project_id = 2;
   */ _define_property(this, "toCaptureProjectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitSurgeryComponent components = 3;
   */ _define_property(this, "components", []), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string request_id = 5;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: bool proposal_review_ack = 6;
   */ _define_property(this, "proposalReviewAck", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MovePursuitComponentsRequest, "runtime", proto3);
_define_property(MovePursuitComponentsRequest, "typeName", "mono.projectdata.v1.MovePursuitComponentsRequest");
_define_property(MovePursuitComponentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "components",
            kind: "message",
            T: PursuitSurgeryComponent,
            repeated: true
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposal_review_ack",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MovePursuitComponentsResponse
 */ export class MovePursuitComponentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MovePursuitComponentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MovePursuitComponentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MovePursuitComponentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MovePursuitComponentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PursuitSurgeryEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MovePursuitComponentsResponse, "runtime", proto3);
_define_property(MovePursuitComponentsResponse, "typeName", "mono.projectdata.v1.MovePursuitComponentsResponse");
_define_property(MovePursuitComponentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: PursuitSurgeryEvent
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitSurgeryRequest
 */ export class ListPursuitSurgeryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitSurgeryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitSurgeryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitSurgeryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitSurgeryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitSurgeryRequest, "runtime", proto3);
_define_property(ListPursuitSurgeryRequest, "typeName", "mono.projectdata.v1.ListPursuitSurgeryRequest");
_define_property(ListPursuitSurgeryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitSurgeryEvent
 */ export class PursuitSurgeryEvent extends Message {
    static fromBinary(bytes, options) {
        return new PursuitSurgeryEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitSurgeryEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitSurgeryEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitSurgeryEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * split | merge | move | link | detach
   *
   * @generated from field: string op = 2;
   */ _define_property(this, "op", ""), /**
   * label empty when the caller may not read that pursuit
   *
   * @generated from field: mono.projectdata.v1.EntityRef from = 3;
   */ _define_property(this, "from", void 0), /**
   * @generated from field: mono.projectdata.v1.EntityRef to = 4;
   */ _define_property(this, "to", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitSurgeryComponent moved = 5;
   */ _define_property(this, "moved", []), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string actor_display_name = 7;
   */ _define_property(this, "actorDisplayName", ""), /**
   * RFC3339
   *
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitSurgeryEvent, "runtime", proto3);
_define_property(PursuitSurgeryEvent, "typeName", "mono.projectdata.v1.PursuitSurgeryEvent");
_define_property(PursuitSurgeryEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "op",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from",
            kind: "message",
            T: EntityRef
        },
        {
            no: 4,
            name: "to",
            kind: "message",
            T: EntityRef
        },
        {
            no: 5,
            name: "moved",
            kind: "message",
            T: PursuitSurgeryComponent,
            repeated: true
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "actor_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitSurgeryResponse
 */ export class ListPursuitSurgeryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitSurgeryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitSurgeryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitSurgeryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitSurgeryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitSurgeryEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitSurgeryResponse, "runtime", proto3);
_define_property(ListPursuitSurgeryResponse, "typeName", "mono.projectdata.v1.ListPursuitSurgeryResponse");
_define_property(ListPursuitSurgeryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: PursuitSurgeryEvent,
            repeated: true
        }
    ]));
